import Link from 'next/link'
import styled from 'styled-components'
import { MultipleAuthorsSelectRecord } from 'types'

import { Container } from '@/components/shared/Container'

import { DatoImage } from '@/elements/global/DatoImage'

const StyledAuthorRow = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledAuthor = styled.div`
  margin-bottom: 22px;
  a {
    display: flex;
    text-decoration: none;
    align-items: center;
    color: ${(props) => props.theme.v2.onSurface.text};
  }
`
const StyledAuthorImage = styled.div`
  margin-right: 18px;
  width: 82px;
  height: 82px;
  border-radius: 50%;
  overflow: hidden;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    width: 56px;
    height: 56px;
  }
`
const StyledAuthorText = styled.div`
  flex: 1;
  span,
  strong {
    display: block;
  }
  span {
    color: ${(props) => props.theme.v2.text.secondary};
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: 14px;
    line-height: 20px;
  }
`

export const MultipleAuthorsSelect = ({ record }: { record: MultipleAuthorsSelectRecord }) => {
  return (
    <Container $size="narrow">
      <StyledAuthorRow>
        {record.authors.map((author) => (
          <StyledAuthor className="author" key={author.name}>
            <Link href={`/learn/${author.slug}`} passHref>
              <StyledAuthorImage>
                <DatoImage data={author.authorImage.responsiveImage} />
              </StyledAuthorImage>
              <StyledAuthorText>
                <strong>
                  {author.name}
                  {author.qualifications && <>, {author.qualifications}</>}
                </strong>
                <span>{author.jobTitle}</span>
              </StyledAuthorText>
            </Link>
          </StyledAuthor>
        ))}
      </StyledAuthorRow>
    </Container>
  )
}
